<template>
  <v-dialog v-model="error.isDisplayed" max-width="500">
    <v-card>
      <v-card-title class="headline">{{ $t('rooms.errorDialog.title') }}</v-card-title>
      <v-card-text>
        <p class="error-notAllowedError" v-for="(errorMessage, index) in errorMessages" :key="index">
          {{ `${index + 1}. ${errorMessage}` }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeError">ok</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ErrorDialog',

  props: {
    error: Object
  },

  methods: {
    closeError() {
      this.$emit('close-error')
    }
  },

  computed: {
    errorMessages() {
      let errorMessage = []

      switch (this.error.name) {
        // User has disabled the input device for the browser in the system settings OR User's machine does not have any such input device connected to it
        case 'NotFoundError':
          errorMessage.push(this.$t('twilioError.enableInput-1'))
          errorMessage.push(this.$t('twilioError.enableInput-2'))
          break

        // User has denied permission for your app to access the input device, either by clicking the “deny” button on the permission dialog,
        // or by going to the browser settings OR User has denied permission for your app by dismissing the permission dialog
        case 'NotAllowedError':
          errorMessage.push(this.$t('twilioError.NotAllowedError-1'))
          errorMessage.push(this.$t('twilioError.NotAllowedError-1'))
          break

        // Your app is being served from a non-localhost non-secure context
        case 'NotReadableError':
          errorMessage.push(this.$t('twilioError.NotReadableError'))
          break

        // The browser could not start media capture with the input device even after the user gave permission,
        // probably because another app or tab has reserved the input device
        case 'OverconstrainedError':
          errorMessage.push(this.$t('twilioError.OverconstrainedError'))
          break

        // The input device could not satisfy the requested media constraints
        case 'TypeError':
          errorMessage.push(this.$t('twilioError.https'))
          break

        default:
          errorMessage.push(this.$t('twilioError.reload'))
          break
      }

      return errorMessage
    }
  }
}
</script>

<style lang="sass" scoped>
.error-notAllowedError
  opacity: .6
</style>
